import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FiArrowLeftCircle, FiArrowRightCircle } from "react-icons/fi";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import * as S from "./DataSlider.styles";
import styled from "styled-components";

// Create styled component for custom pagination
const PaginationContainer = styled.div`
  .swiper-pagination-bullet {
    background: #a5b5af;
    opacity: 1;
    width: 10px;
    height: 10px;
    margin: 0 5px;
    transform: scale(1) !important; /* Force all bullets to be same size */
  }

  .swiper-pagination-bullet-active {
    background: #2ecf96;
    transform: scale(1) !important; /* Ensure active bullet doesn't scale */
  }

  /* Remove dynamic bullets positioning */
  .swiper-pagination {
    position: relative;
    bottom: 0;
    margin-top: 15px;
  }
`;

const DataSlider = ({
  slides = [],
  renderSlideContent,
  navigationColor = "#2ECF96",
  swiperProps = {},
  styleProps = {},
  slidesPerView = 1,
}) => {
  const PrevArrow = (props) => {
    const { onClick } = props;
    return (
      <FiArrowLeftCircle
        onClick={onClick}
        color="rgb(160, 195, 221)"
        width={"50%"}
      />
    );
  };

  const NextArrow = (props) => {
    const { onClick } = props;
    return <FiArrowRightCircle onClick={onClick} color={navigationColor} />;
  };

  return (
    <PaginationContainer>
      <S.SliderContainer {...styleProps.sliderContainer}>
        <Swiper
          spaceBetween={30}
          slidesPerView={slidesPerView}
          loop
          modules={[EffectCoverflow, Navigation, Pagination]}
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          pagination={{
            clickable: true,
            dynamicBullets: false,
            el: ".swiper-pagination",
          }}
          {...swiperProps}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <S.SlideBox {...styleProps.slideBox}>
                {renderSlideContent(slide, index, styleProps)}
              </S.SlideBox>
            </SwiperSlide>
          ))}
          <S.CustomNavigation {...styleProps.customNavigation}>
            <div className="swiper-button-prev custom">
              <PrevArrow onClick={() => {}} />
            </div>
            <div className="swiper-button-next custom">
              <NextArrow onClick={() => {}} />
            </div>
          </S.CustomNavigation>
        </Swiper>
        {/* Ensure pagination element is outside the Swiper component */}
        <div
          className="swiper-pagination"
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "center",
          }}
        />
      </S.SliderContainer>
    </PaginationContainer>
  );
};

export default DataSlider;
